import { ConfigurableProduct } from '@magentoTypes'
import { DetailEntry } from '~/modules/PDP/components/DetailsTable'

export const mapProductAttributesDetails = (product: ConfigurableProduct): Array<DetailEntry> => {
  const {
    sku,
    benuta_living_area,
    benuta_fuellmaterial,
    benuta_floor_heating,
    benuta_motive_design,
    benuta_pile_height,
    benuta_production_type,
    benuta_pile_material,
    manufacturer,
    benuta_test_seal,
    benuta_waschbar,
    dimensions,
    benuta_rueckseite,
    warning_code,
    lagerungshinweise,
    ingredients,
  } = product

  return [
    {
      name: 'Living space',
      value: benuta_living_area,
      valueStr: 'benuta_living_area',
      type: 'choice',
    },
    {
      name: 'Filling Material',
      value: benuta_fuellmaterial,
      valueStr: 'benuta_fuellmaterial',
      type: 'choice',
    },
    {
      name: 'Underfloor heating',
      value: benuta_floor_heating,
      valueStr: 'benuta_floor_heating',
      type: 'choice',
    },
    { name: 'Brand', value: manufacturer, valueStr: 'manufacturer', type: 'choice' },
    {
      name: 'Motif / Design',
      value: benuta_motive_design,
      valueStr: 'benuta_motive_design',
      type: 'choice',
    },
    {
      name: 'Pile height',
      value: benuta_pile_height,
      valueStr: 'benuta_pile_height',
      type: 'choice',
    },
    {
      name: 'Pile material',
      value: benuta_pile_material,
      valueStr: 'benuta_pile_material',
      type: 'choice',
    },
    {
      name: 'Back material',
      value: benuta_rueckseite,
      valueStr: 'benuta_rueckseite',
      type: 'choice',
    },
    { name: 'Seal', value: benuta_test_seal, valueStr: 'benuta_test_seal', type: 'choice' },
    {
      name: 'Care Instructions',
      value: benuta_waschbar,
      valueStr: 'benuta_waschbar',
      type: 'choice',
    },
    { name: 'Dimensions', value: dimensions, valueStr: 'dimensions', type: 'text' },
    {
      name: 'Type of manufacture',
      value: benuta_production_type,
      valueStr: 'benuta_production_type',
      type: 'choice',
    },
    { name: 'Ingredients', value: ingredients, valueStr: 'ingredients', type: 'text' },
    {
      name: 'Storage instructions',
      value: lagerungshinweise,
      valueStr: 'lagerungshinweise',
      type: 'text',
    },
    { name: 'Warning code', value: warning_code, valueStr: 'warning_code', type: 'text' },
    // Ensure that SKU is last item unless you know what you are doing
    { name: 'Item number', value: sku, valueStr: 'sku', type: 'text' },
  ]
}
